import { H4 } from 'UIComponents/elements/headings';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ErrorMessage = ({
  title,
  body
}) => {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    className: "m-all-5 m-top-15",
    illustration: "warning",
    title: /*#__PURE__*/_jsx(H4, {
      children: title
    }),
    illustrationProps: {
      width: '100'
    },
    children: body
  });
};